<template>
    <el-container class="up-main">
      <el-aside width="211px">
          <left-menu :active="5"></left-menu>
      </el-aside>
      <el-main class="u-main">
        <div class="i-form">
            <h3 class="h-title">业务进展情况</h3>
            <table class="form-table" cellspacing="0" cellpadding="0">
                <tr>
                    <th>当前状态</th>
                    <td><span :style="{color:detailData.status == '2'||detailData.status == '4'?'#B82121':'#42AE0E'}">{{stateFormat(detailData.status)}}</span></td>         
                </tr>
                <tr>
                    <th>审核意见</th>
                    <td>{{exList.auditContent || '--'}}</td>         
                </tr>
                <tr>
                    <th>HASH值</th>
                    <td>{{detailData.blockchainHash}}</td>         
                </tr>
            </table>
        </div>
        <div class="i-form">
            <h3 class="h-title">债权治理详情</h3>
            <h3 class="form-title">服务基础信息</h3>
            <table class="form-table" cellspacing="0" cellpadding="0">
                <tr>
                    <th>选择管理人</th>
                    <td>{{detailData.lawFirmName}}</td>
                </tr>
                <tr>
                    <th>权威节点</th>
                    <td>{{nodeFormat(detailData.authorityNode)}}</td>
                </tr>
                <tr>
                    <th>存储类型</th>
                    <td>{{typeFormat(detailData.saveType)}}</td>
                </tr>
                <tr>
                    <th>治理标的名称</th>
                    <td>{{detailData.targetName}}</td>
                </tr>
                <tr>
                    <th>债权人名称</th>
                    <td>{{detailData.creditorName}}</td>
                </tr>
                <tr>
                    <th>债务人名称</th>
                    <td>{{detailData.debtorName}}</td>
                </tr>
                <tr>
                    <th>确认方名称</th>
                    <td>{{detailData.confirmerName}}</td>
                </tr>
                <tbody v-for="item in 10" :key="'main'+item">
                    <tr v-if="detailData['subjectName'+item]">
                        <th>增信主体{{item}}名称</th>
                        <td>{{detailData['subjectName'+item]}}</td>
                    </tr>
                </tbody>

                <tr>
                    <th>债权规模(万元)</th>
                    <td>{{setComdify(detailData.creditAmount, 2)}}</td>
                </tr>
                <tr>
                    <th>债权余额(万元)</th>
                    <td>{{setComdify(detailData.creditBlance, 2)}}</td>
                </tr>
                <tr>
                    <th>委托治理规模(万元)</th>
                    <td>{{setComdify(detailData.entrustAmount, 2)}}</td>
                </tr>
                <tr>
                    <th>债权清偿方式</th>
                    <td>{{repayFormat(detailData.repaymentMethod)}}</td>
                </tr>
                <tr>
                    <th>债权到期日</th>
                    <td>{{detailData.creditExpire}}</td>
                </tr>
                <tr>
                    <th>委托期限</th>
                    <td>{{detailData.entrustPeriodStart}}~{{detailData.entrustPeriodEnd}}</td>
                </tr>
                <tr>
                    <th>担保措施</th>
                    <td colspan="3">{{detailData.guaranteeStep}}</td>
                </tr>
            </table>
            <h3 class="form-title">存储方基本信息</h3>
            <table class="form-table" cellspacing="0" cellpadding="0">
                <tr>
                    <th>存储方名称</th>
                    <td>{{detailData.submitName}}</td>
                </tr>
                <tr>
                    <th>会员编号</th>
                    <td>{{detailData.createBy}}</td>
                </tr>
                <tr>
                    <th>统一社会信用代码</th>
                    <td>{{detailData.socialCreditCode}}</td>
                </tr>
                <tr>
                    <th>法定代表人姓名</th>
                    <td>{{detailData.legalName}}</td>
                </tr>
                <tr>
                    <th>注册地址</th>
                    <td>{{detailData.registerAddress}}</td>
                </tr>
                <tr>
                    <th>注册资金(万元)</th>
                    <td>{{detailData.registerCapital}}</td>
                </tr>
                <tr>
                    <th>主体类型</th>
                    <td>{{subjectTypeFormat(detailData.subjectType)}}</td>
                </tr>
                <tr>
                    <th>联系人姓名</th>
                    <td>{{detailData.contactsName}}</td>
                </tr>
                <tr>
                    <th>联系电话</th>
                    <td>{{detailData.contactsTel}}</td>
                </tr>
                <tr>
                    <th>治理服务指定邮箱</th>
                    <td>{{detailData.saveMail}}</td>
                </tr>
            </table>
            <h3 class="form-title">债权治理服务项目选择</h3>
            <table class="form-table" cellspacing="0" cellpadding="0">
                <tr>
                    <th>标的债权治理事项信息公示服务</th>
                    <td>{{isFormat(detailData.isPublicityService)}}</td>
                </tr>
                <tr>
                    <th>资产评价服务</th>
                    <td>{{isFormat(detailData.isAssetService)}}</td>
                </tr>
                <tr>
                    <th>资产评价服务周期选择</th>
                    <td>{{cycleFormat(detailData.assetServiceSelect)}}</td>
                </tr>
                <tr>
                    <th>债务人偿付提示服务</th>
                    <td>{{isFormat(detailData.isDebtorTipsService)}}</td>
                </tr>
                <tr>
                    <th>治理事项存储服务</th>
                    <td>{{isFormat(detailData.isSaveService)}}</td>
                </tr>
                <tr>
                    <th>标的债权项下资金由管理人指定第三方提供结算服务</th>
                    <td>{{isFormat(detailData.isSettlementService)}}</td>
                </tr>
                <tr v-if="detailData.isSettlementService == '0'">
                    <th>户名</th>
                    <td>{{detailData.settlementName}}</td>
                </tr>
                <tr v-if="detailData.isSettlementService == '0'">
                    <th>账号</th>
                    <td>{{detailData.settlementBank}}</td>
                </tr>
                <tr v-if="detailData.isSettlementService == '0'">
                    <th>开户行</th>
                    <td>{{detailData.settlementAccount}}</td>
                </tr>
            </table>
            <h3 class="form-title">主体文件</h3>
            <table class="form-table" cellspacing="0" cellpadding="0">  
                <tr>
                    <th>债权人名称</th>
                    <td>{{detailData.creditorName}}</td>
                </tr>  
                <tr>
                    <th>三证合一</th>
                    <td><span class="file-link" v-if="detailData.creditorThreeCertOneFile[0]" @click="downloadFile(detailData.creditorThreeCertOneFile[0].url)">{{detailData.creditorThreeCertOneFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>法定代表人身份证</th>
                    <td><span class="file-link" v-if="detailData.creditorIdentityCardFile[0]" @click="downloadFile(detailData.creditorIdentityCardFile[0].url)">{{detailData.creditorIdentityCardFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>公司简介</th>
                    <td><span class="file-link" v-if="detailData.creditorCompanyProfileFile[0]" @click="downloadFile(detailData.creditorCompanyProfileFile[0].url)">{{detailData.creditorCompanyProfileFile[0].name}}</span></td>
                </tr>  

                <tr>
                    <th>公司简章</th>
                    <td><span class="file-link" v-if="detailData.creditorCompanyByelawFile[0]" @click="downloadFile(detailData.creditorCompanyByelawFile[0].url)">{{detailData.creditorCompanyByelawFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>高管人员简历</th>
                    <td><span class="file-link" v-if="detailData.creditorGgPersonResumeFile[0]" @click="downloadFile(detailData.creditorGgPersonResumeFile[0].url)">{{detailData.creditorGgPersonResumeFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>近两年财务报表及最近一期财务报表</th>
                    <td><span class="file-link" v-if="detailData.creditorFinanceReportFile[0]" @click="downloadFile(detailData.creditorFinanceReportFile[0].url)">{{detailData.creditorFinanceReportFile[0].name}}</span></td>
                </tr> 
                <tr>
                    <th>灰名单查询结果：</th>
                    <td><span class="file-link" v-if="detailData.creditorRiskResultFile[0]" @click="downloadFile(detailData.creditorRiskResultFile[0].url)">{{detailData.creditorRiskResultFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>电子邮箱</th>
                    <td>{{detailData.creditorMail}}</td>
                </tr> 
                <tr>
                    <th>征信报告</th>
                    <td><span class="file-link" v-if="detailData.creditorCreditReportFile[0]" @click="downloadFile(detailData.creditorCreditReportFile[0].url)">{{detailData.creditorCreditReportFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>信用报告</th>
                    <td><span class="file-link" v-if="detailData.creditorThinktankReportFile[0]" @click="downloadFile(detailData.creditorThinktankReportFile[0].url)">{{detailData.creditorThinktankReportFile[0].name}}</span></td>
                </tr> 

            </table>
            <table class="form-table" cellspacing="0" cellpadding="0">  
                <tr>
                    <th>债务人名称</th>
                    <td>{{detailData.debtorName}}</td>
                </tr>  
                <tr>
                    <th>三证合一</th>
                    <td ><span class="file-link" v-if="detailData.debtorThreeCertOneFile[0]" @click="downloadFile(detailData.debtorThreeCertOneFile[0].url)">{{detailData.debtorThreeCertOneFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>法定代表人身份证</th>
                    <td><span class="file-link" v-if="detailData.debtorIdentityCardFile[0]" @click="downloadFile(detailData.debtorIdentityCardFile[0].url)">{{detailData.debtorIdentityCardFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>公司简介</th>
                    <td><span class="file-link" v-if="detailData.debtorCompanyProfileFile[0]" @click="downloadFile(detailData.debtorCompanyProfileFile[0].url)">{{detailData.debtorCompanyProfileFile[0].name}}</span></td>
                </tr>  

                <tr>
                    <th>公司简章</th>
                    <td><span class="file-link" v-if="detailData.debtorCompanyByelawFile[0]" @click="downloadFile(detailData.debtorCompanyByelawFile[0].url)">{{detailData.debtorCompanyByelawFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>高管人员简历</th>
                    <td><span class="file-link" v-if="detailData.debtorGgPersonResumeFile[0]" @click="downloadFile(detailData.debtorGgPersonResumeFile[0].url)">{{detailData.debtorGgPersonResumeFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>近两年财务报表及最近一期财务报表</th>
                    <td><span class="file-link" v-if="detailData.debtorFinanceReportFile[0]" @click="downloadFile(detailData.debtorFinanceReportFile[0].url)">{{detailData.debtorFinanceReportFile[0].name}}</span></td>
                </tr> 
                <tr>
                    <th>灰名单查询结果：</th>
                    <td><span class="file-link" v-if="detailData.debtorRiskResultFile[0]" @click="downloadFile(detailData.debtorRiskResultFile[0].url)">{{detailData.debtorRiskResultFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>电子邮箱</th>
                    <td>{{detailData.debtorMail}}</td>
                </tr> 
                <tr>
                    <th>征信报告</th>
                    <td><span class="file-link" v-if="detailData.debtorCreditReportFile[0]" @click="downloadFile(detailData.debtorCreditReportFile[0].url)">{{detailData.debtorCreditReportFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>信用报告</th>
                    <td><span class="file-link" v-if="detailData.debtorThinktankReportFile[0]" @click="downloadFile(detailData.debtorThinktankReportFile[0].url)">{{detailData.debtorThinktankReportFile[0].name}}</span></td>
                </tr> 
            </table>
            
            <div v-for="item in subjectNum" :key="`main${item}`">
                <table v-if="detailData[`subjectName${item}`]" class="form-table" cellspacing="0" cellpadding="0">  
                    <tr>
                        <th>增信主体{{item}}名称</th>
                        <td>{{detailData[`subjectName${item}`]}}</td>
                    </tr>  
                    <tr>
                        <th>三证合一</th>
                        <td ><span class="file-link" v-if="subjectFile[`subjectThreeCertOneFile${item}`][0]" @click="downloadFile(subjectFile[`subjectThreeCertOneFile${item}`][0].url)">{{subjectFile[`subjectThreeCertOneFile${item}`][0].name}}</span></td>
                    </tr>  
                    <tr>
                        <th>法定代表人身份证</th>
                        <td><span class="file-link" v-if="subjectFile[`subjectIdentityCardFile${item}`][0]" @click="downloadFile(subjectFile[`subjectIdentityCardFile${item}`][0].url)">{{subjectFile[`subjectIdentityCardFile${item}`][0].name}}</span></td>
                    </tr>  
                    <tr>
                        <th>公司简介</th>
                        <td><span class="file-link" v-if="subjectFile[`subjectCompanyProfileFile${item}`][0]" @click="downloadFile(subjectFile[`subjectCompanyProfileFile${item}`][0].url)">{{subjectFile[`subjectCompanyProfileFile${item}`][0].name}}</span></td>
                    </tr>  

                    <tr>
                        <th>公司简章</th>
                        <td><span class="file-link" v-if="subjectFile[`subjectCompanyByelawFile${item}`][0]" @click="downloadFile(subjectFile[`subjectCompanyByelawFile${item}`][0].url)">{{subjectFile[`subjectCompanyByelawFile${item}`][0].name}}</span></td>
                    </tr>  
                    <tr>
                        <th>高管人员简历</th>
                        <td><span class="file-link" v-if="subjectFile[`subjectGgPersonResumeFile${item}`][0]" @click="downloadFile(subjectFile[`subjectGgPersonResumeFile${item}`][0].url)">{{subjectFile[`subjectGgPersonResumeFile${item}`][0].name}}</span></td>
                    </tr>  
                    <tr>
                        <th>近两年财务报表及最近一期财务报表</th>
                        <td><span class="file-link" v-if="subjectFile[`subjectFinanceReportFile${item}`][0]" @click="downloadFile(subjectFile[`subjectFinanceReportFile${item}`][0].url)">{{subjectFile[`subjectFinanceReportFile${item}`][0].name}}</span></td>
                    </tr> 
                    <tr>
                        <th>灰名单查询结果：</th>
                        <td><span class="file-link" v-if="subjectFile[`subjectRiskResultFile${item}`][0]" @click="downloadFile(subjectFile[`subjectRiskResultFile${item}`][0].url)">{{subjectFile[`subjectRiskResultFile${item}`][0].name}}</span></td>
                    </tr>  
                    <tr>
                        <th>电子邮箱</th>
                        <td>{{subjectFile[`subjectMail${item}`]}}</td>
                    </tr> 
                    <tr>
                        <th>征信报告</th>
                        <td><span class="file-link" v-if="subjectFile[`subjectCreditReportFile${item}`][0]" @click="downloadFile(subjectFile[`subjectCreditReportFile${item}`][0].url)">{{subjectFile[`subjectCreditReportFile${item}`][0].name}}</span></td>
                    </tr>  
                    <tr>
                        <th>信用报告</th>
                        <td><span class="file-link" v-if="subjectFile[`subjectThinktankReportFile${item}`][0]" @click="downloadFile(subjectFile[`subjectThinktankReportFile${item}`][0].url)">{{subjectFile[`subjectThinktankReportFile${item}`][0].name}}</span></td>
                    </tr> 
                </table>
            </div>
            
            <h3 class="form-title">服务文本</h3>
            <table class="form-table" cellspacing="0" cellpadding="0">   
                <tr>
                    <th>债权治理申请书</th>
                    <td ><span class="file-link" v-if="detailData.serviceApplyFile[0]" @click="downloadFile(detailData.serviceApplyFile[0].url)">{{detailData.serviceApplyFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>推介服务协议</th>
                    <td><span class="file-link" v-if="detailData.serviceSuggestProtocolFile[0]" @click="downloadFile(detailData.serviceSuggestProtocolFile[0].url)">{{detailData.serviceSuggestProtocolFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>债权治理协议</th>
                    <td><span class="file-link" v-if="detailData.serviceGovernProtocolFile[0]" @click="downloadFile(detailData.serviceGovernProtocolFile[0].url)">{{detailData.serviceGovernProtocolFile[0].name}}</span></td>
                </tr>  

                <tr>
                    <th>债权治理公告【信息公示服务】</th>
                    <td><span class="file-link" v-if="detailData.serviceNoticeFile[0]" @click="downloadFile(detailData.serviceNoticeFile[0].url)">{{detailData.serviceNoticeFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>债权到期偿付提示函</th>
                    <td><span class="file-link" v-if="detailData.serviceTipsLetterFile[0]" @click="downloadFile(detailData.serviceTipsLetterFile[0].url)">{{detailData.serviceTipsLetterFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>债权到期偿付事宜回函</th>
                    <td><span class="file-link" v-if="detailData.serviceReasonLetterFile[0]" @click="downloadFile(detailData.serviceReasonLetterFile[0].url)">{{detailData.serviceReasonLetterFile[0].name}}</span></td>
                </tr> 
                <tr>
                    <th>债权治理服务终止通知书</th>
                    <td><span class="file-link" v-if="detailData.serviceAdviceFile[0]" @click="downloadFile(detailData.serviceAdviceFile[0].url)">{{detailData.serviceAdviceFile[0].name}}</span></td>
                </tr>  
                <tr>
                    <th>授权划付通知书【资金结算服务】</th>
                    <td><span class="file-link" v-if="detailData.serviceTransferAdviceFile[0]" @click="downloadFile(detailData.serviceTransferAdviceFile[0].url)">{{detailData.serviceTransferAdviceFile[0].name}}</span></td>
                </tr>   
            </table>
            <h3 class="form-title">拟存储文件</h3>
            <table class="form-table" cellspacing="0" cellpadding="0">                      
                <tr>
                    <th>拟存储文件</th>
                    <td><span class="file-link" v-if="detailData.planSaveFile[0]" @click="downloadFile(detailData.planSaveFile[0].url)">{{detailData.planSaveFile[0].name}}</span></td>
                </tr>  
            </table>
        </div>
    </el-main>
  </el-container>
</template>
<script>
    import leftMenu from '../contract/components/leftMenu'
	export default {
		name: "CDetail",
        components: {
            leftMenu
        },
		data() {
			return {
                setComdify: this.comdify,
				detailData: {},
                subjectFile: {},
				id: null,
				taskKey: '',
				taskId: '',
				exList: {},	
                typeOptions: [],
                stateOptions: [],
                cycleOptions: [],
                repayOptions: [],
                isOptions: [],
                subjectTypeOptions: [],
                subjectNum: 1
			}
    },
    created() {
        window.scrollTo(0,0);
        this.id = this.$route.query.id;
        this.$api.api.getDicts("zqzl_state").then(response => {
            this.stateOptions = response.data;
        });
        this.$api.api.getDicts("zqzl_save_type").then(response => {
            this.typeOptions = response.data;
        });
        this.$api.api.getDicts("service_cycle").then(response => {
            this.cycleOptions = response.data;
        });
        this.$api.api.getDicts("zqzl_subject_type").then(response => {
            this.subjectTypeOptions = response.data;
        });
        this.$api.api.getDicts("payment_method").then(response => {
            this.repayOptions = response.data;
        });
        this.$api.api.getDicts("is_not").then(response => {
            this.isOptions = response.data;
        });
    },
    mounted() {
        this.getDetial();	
	},
    methods: {
        cycleFormat (val) {
            if(val){
                let arr = val.split(',')
                let str = ''
                arr.forEach((item, i) => {
                    if(i != 0){
                        str += ','
                    }
                    str += this.selectDictLabel(this.cycleOptions, item);
                })
                return str
            }          
        }, 
        repayFormat (val) {
            return this.selectDictLabel(this.repayOptions, val);
        },
        isFormat(value) {
            return this.selectDictLabel(this.isOptions, value);
        }, 
        subjectTypeFormat (val) {
            return this.selectDictLabel(this.subjectTypeOptions, val);
        }, 
        downloadFile(url){
            this.$api.api.downloadFile(url)
        },
        selectDictLabel(datas, value) {
            var actions = [];
            Object.keys(datas).some((key) => {
                if (datas[key].dictValue == ('' + value)) {
                    actions.push(datas[key].dictLabel);
                    return true;
                }
            })
            return actions.join('');
        }, 
        nodeFormat(val){
            if(val){
                let arr = JSON.parse(val)
                let nodeName = []
                arr.forEach(item => {
                    nodeName.push(item.name)
                })
                return nodeName.join('，')
            }else {
                return ''
            }
            
        },
        typeFormat (val) {
            return this.selectDictLabel(this.typeOptions, val);
        }, 
        stateFormat (val) {
            return this.selectDictLabel(this.stateOptions, val);
        }, 
        //获取详情
        getDetial() {
            this.$api.creditorsRights.creDetail(this.id).then(res => {
                this.listLoading = false;
                if(res.code==200){
                    this.detailData = Object.assign({}, res.data); 	
                    this.exList = res.data.contractProjectAuditList[0] || {}

                    // 债权人
                    this.detailData.creditorThreeCertOneFile = JSON.parse(this.detailData.creditorThreeCertOneFile || '[]');
                    
                    this.detailData.creditorIdentityCardFile = JSON.parse(this.detailData.creditorIdentityCardFile || '[]');
                    this.detailData.creditorCompanyProfileFile = JSON.parse(this.detailData.creditorCompanyProfileFile || '[]');
                    this.detailData.creditorCompanyByelawFile = JSON.parse(this.detailData.creditorCompanyByelawFile || '[]');
                    this.detailData.creditorGgPersonResumeFile = JSON.parse(this.detailData.creditorGgPersonResumeFile || '[]');
                    this.detailData.creditorFinanceReportFile = JSON.parse(this.detailData.creditorFinanceReportFile || '[]');
                    this.detailData.creditorRiskResultFile = JSON.parse(this.detailData.creditorRiskResultFile || '[]');
                    this.detailData.creditorCreditReportFile = JSON.parse(this.detailData.creditorCreditReportFile || '[]');
                    this.detailData.creditorThinktankReportFile = JSON.parse(this.detailData.creditorThinktankReportFile || '[]');

                    // 债务人
                    this.detailData.debtorThreeCertOneFile = JSON.parse(this.detailData.debtorThreeCertOneFile || '[]');
                    this.detailData.debtorIdentityCardFile = JSON.parse(this.detailData.debtorIdentityCardFile || '[]');
                    this.detailData.debtorCompanyProfileFile = JSON.parse(this.detailData.debtorCompanyProfileFile || '[]');
                    this.detailData.debtorCompanyByelawFile = JSON.parse(this.detailData.debtorCompanyByelawFile || '[]');
                    this.detailData.debtorGgPersonResumeFile = JSON.parse(this.detailData.debtorGgPersonResumeFile || '[]');
                    this.detailData.debtorFinanceReportFile = JSON.parse(this.detailData.debtorFinanceReportFile || '[]');
                    this.detailData.debtorRiskResultFile = JSON.parse(this.detailData.debtorRiskResultFile || '[]');
                    this.detailData.debtorCreditReportFile = JSON.parse(this.detailData.debtorCreditReportFile || '[]');
                    this.detailData.debtorThinktankReportFile = JSON.parse(this.detailData.debtorThinktankReportFile || '[]');

                    // 增信主体
                    for(let j=10; j>=1; j--){
                        if(this.detailData[`subjectName${j}`]){
                            this.subjectNum = j;
                            break;
                        }else {
                            this.subjectNum = 1
                        }
                    }
                    // 增信主体
                    this.subjectFile = this.detailData.contractCreditorSubjectFile || {}
                    for(let i=1; i <= this.subjectNum; i++){
                        this.subjectFile[`subjectThreeCertOneFile${i}`] = JSON.parse(this.subjectFile[`subjectThreeCertOneFile${i}`] || '[]');
                        this.subjectFile[`subjectIdentityCardFile${i}`] = JSON.parse(this.subjectFile[`subjectIdentityCardFile${i}`] || '[]');
                        this.subjectFile[`subjectCompanyProfileFile${i}`] = JSON.parse(this.subjectFile[`subjectCompanyProfileFile${i}`] || '[]');
                        this.subjectFile[`subjectCompanyByelawFile${i}`] = JSON.parse(this.subjectFile[`subjectCompanyByelawFile${i}`] || '[]');
                        this.subjectFile[`subjectGgPersonResumeFile${i}`] = JSON.parse(this.subjectFile[`subjectGgPersonResumeFile${i}`] || '[]');
                        this.subjectFile[`subjectFinanceReportFile${i}`] = JSON.parse(this.subjectFile[`subjectFinanceReportFile${i}`] || '[]');
                        this.subjectFile[`subjectRiskResultFile${i}`] = JSON.parse(this.subjectFile[`subjectRiskResultFile${i}`] || '[]');
                        this.subjectFile[`subjectCreditReportFile${i}`] = JSON.parse(this.subjectFile[`subjectCreditReportFile${i}`] || '[]');
                        this.subjectFile[`subjectThinktankReportFile${i}`] = JSON.parse(this.subjectFile[`subjectThinktankReportFile${i}`] || '[]');
                    }

                    this.detailData.serviceApplyFile = JSON.parse(this.detailData.serviceApplyFile || '[]');
                    this.detailData.serviceSuggestProtocolFile = JSON.parse(this.detailData.serviceSuggestProtocolFile || '[]');
                    this.detailData.serviceGovernProtocolFile = JSON.parse(this.detailData.serviceGovernProtocolFile || '[]');
                    this.detailData.serviceNoticeFile = JSON.parse(this.detailData.serviceNoticeFile || '[]');
                    this.detailData.serviceTipsLetterFile = JSON.parse(this.detailData.serviceTipsLetterFile || '[]');
                    this.detailData.serviceReasonLetterFile = JSON.parse(this.detailData.serviceReasonLetterFile || '[]');
                    this.detailData.serviceAdviceFile = JSON.parse(this.detailData.serviceAdviceFile || '[]');
                    this.detailData.serviceTransferAdviceFile = JSON.parse(this.detailData.serviceTransferAdviceFile || '[]');
                    this.detailData.planSaveFile = JSON.parse(this.detailData.planSaveFile || '[]');
                }else {
                    this.$message.error(res.msg);
                }    
            });      
        },
    }
}
</script>
<style lang="less">
@import '../style.less';
</style>